import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

export interface ReportTabsProps {
  activeTabKey: string;
  tabList: TabProps[];
  onTabClick: () => void;
}

export interface TabProps {
  title: string;
  type: string;
  url: string;
}

class ReportTabs extends Component<ReportTabsProps, any> {
  render() {
    return (
      <div className='uc-tabs u-ph16'>
        {this.props.tabList.map((row) => (
          <div key={row.type} data-testid='tabList'>
            <Link
              className={classNames('uc-tab', this.props.activeTabKey === row.type && 'uc-tab--active')}
              to={row.url}
              data-testid-e2e='reportTabs-tab'
              onClick={() => this.props.onTabClick()}>
              <span className='uc-tab__label' data-testid='title'>
                {row.title}
              </span>
              <div className='uc-tab__indicator' />
            </Link>
          </div>
        ))}
      </div>
    );
  }
}

export default ReportTabs;
